import { Col } from "react-styled-flexboxgrid"
import styled from "styled-components"
import { theme } from "@aistihealth/web-common/src/util/styles/theme"

export const FormCol = styled(Col)`
  margin-bottom: ${theme.spacings.large};
`
